import axios from 'axios';
import { setAccessToken } from '../store/slices/auth/slice.js';
import { BASE_URL, LOGOUT } from '../utils/constants.js';

let store;

export const injectStore = _store => {
  store = _store;
};

const axiosApiFreeClient = axios.create({
  baseURL: `${BASE_URL}/auth`,
});

const axiosApiClient = axios.create({
  baseURL: `${BASE_URL}/api`,
});

axiosApiClient.interceptors.request.use(
  async config => {
    config.headers['X-MY-CSRF'] = '5';
    const token = store.getState().auth.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axiosApiFreeClient.interceptors.request.use(
  async config => {
    config.headers['X-MY-CSRF'] = '5';
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axiosApiClient.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshResponse = await axiosApiFreeClient.post('/w/refresh-token', {}, { withCredentials: true });
        const { accessToken } = refreshResponse.data.data;
        store.dispatch(setAccessToken({ accessToken }));
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (error) {
        store.dispatch({ type: LOGOUT });
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosApiClient;
export { axiosApiFreeClient };
